import styled from 'styled-components';

export const StyledMessageBox = styled.div`
    max-width: 350px;
    width: 100%;
    padding: 1em;
    border: ${(props: any) => '2px solid ' + props.borderColor};
    border-radius: 7px;
    background: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    font-family: ${(props: any) => props.fontFamily};
    h2 {
        font-size: 20px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        text-align: center;
        text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.8);
    }
    p {
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
` as any;
